import { useQuery } from '@tanstack/react-query';

import { OfficeScheduleSettingsViewModel } from 'chaika-types';

import { officeScheduleSettingsQueryOptions } from '@modules/clinics/queries/officeScheduleSettingsQueries';

interface Params {
    officeIds: string[];
}

interface Data {
    settingsByOffice: Map<string, OfficeScheduleSettingsViewModel>;
    isLoading: boolean;
}

export function useOfficeScheduleSettings({ officeIds }: Params): Data {
    const { data: settings = [], isLoading } = useQuery(officeScheduleSettingsQueryOptions.byOffices(officeIds));

    return {
        settingsByOffice: new Map(settings.map(officeSettings => [officeSettings.officeId, officeSettings])),
        isLoading,
    };
}
